var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.clientList),function(client){return _c('div',{key:client.id},[(_vm.showClient(client))?_c('client-list-item',{attrs:{"client":client}}):_vm._e()],1)}),(_vm.isEmptyList)?_c('div',[_c('h5',{staticClass:"text-center"},[_vm._v("Empty list")])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }